<template>
    <v-container fluid grid-list-md>
        <v-layout wrap column>
            <v-flex>
                <h2 class="display-3">Reporte de producción</h2>
                <v-progress-linear :indeterminate="true" :query="true" :active="loading" height="5"></v-progress-linear>
                <v-layout row wrap>
                    <v-flex xs12 sm4>
                        <v-layout row wrap align-center>
                            <v-flex v-if="mostrarEmpresa" xs12 sm12 md6>
                                <empresa-select v-model="d.empresa_id" @input="getRecursos" :filtro="emp"></empresa-select>
                            </v-flex>
                            <v-flex xs12 sm12 md6>
                                <v-select
                                        label="Recurso"
                                        :items="recursos"
                                        v-model="d.recurso_id"
                                        item-text="H1_DESCRI"
                                        item-value="H1_CODIGO"
                                        @change="getOp"
                                ></v-select>
                            </v-flex>
                        </v-layout>
                        <v-layout v-if="selectProd.includes(d.calidad)">
                            <v-flex>
                                <v-text-field label="Búsqueda producto" v-model="d.producto_id" @change="prodSearch" clearable></v-text-field>
                            </v-flex>
                            <v-flex>
                                <v-text-field label="Largo Pza" v-model="d.op.C2_LARGPZA"></v-text-field>
                            </v-flex>
                        </v-layout>
                        <v-layout v-if="selectProd.includes(d.calidad)">
                            <v-flex>
                                <v-subheader>SELECCIONE PRODUCTO</v-subheader>
                                <div class="lista-cont scroll-style" @scroll="handleItemScroll">
                                    <v-list two-line dense>
                                        <template v-for="p in productos">
                                            <v-list-tile @click="prodSeleccion(p)">
                                                <v-list-tile-content>
                                                    <v-list-tile-title>{{ p.B1_COD }}</v-list-tile-title>
                                                    <v-list-tile-sub-title>{{ p.B1_DESC }}</v-list-tile-sub-title>
                                                </v-list-tile-content>
                                            </v-list-tile>
                                            <v-divider></v-divider>
                                        </template>
                                    </v-list>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-layout v-if="d.calidad === 'P'">
                            <v-flex>
                                <v-subheader>SELECCIONE ORDEN</v-subheader>
                                <div class="lista-cont scroll-style">
                                    <v-list three-line dense>
                                        <template v-for="op in ops">
                                            <v-list-tile @click="(opSel)?opSeleccion(op) : ''">
                                                <v-list-tile-content>
                                                    <v-list-tile-title>Orden: {{ op.C2_NUM }} {{ op.C2_ITEM }} {{ op.C2_SEQUEN }} | <b>{{ op.C2_PRODUTO }}</b></v-list-tile-title>
                                                    <v-list-tile-sub-title>Piezas: <b>{{ op.PIEZAS | decimales }}</b> | Largo Pieza: <b>{{ op.C2_LARGPZA | decimales }}</b> | Ancho: <b>{{ op.B1_ANCHO | decimales }}</b></v-list-tile-sub-title>
                                                    <v-list-tile-sub-title>
                                                        Cantidad: Tot. <b>{{ op.C2_QUANT | decimales }} {{ op.C2_UM }}</b>
                                                        | Prod. Web. <b>{{ op.C2_REPWEB | decimales }} {{ op.C2_UM }}</b>
                                                        | Prod. <b>{{ op.C2_QUJE | decimales }} {{ op.C2_UM }}</b>
                                                    </v-list-tile-sub-title>
                                                </v-list-tile-content>
                                                <v-list-tile-action>
                                                    <v-tooltip top v-if="op.anchoFalta">
                                                        <v-icon color="red" slot="activator">error</v-icon>
                                                        <span>Falta dato del ancho</span>
                                                    </v-tooltip>
                                                    <v-tooltip top v-if="op.largoFalta">
                                                        <v-icon color="red" slot="activator">error</v-icon>
                                                        <span>Falta dato del largo de la pieza</span>
                                                    </v-tooltip>
                                                </v-list-tile-action>
                                            </v-list-tile>
                                            <v-divider></v-divider>
                                        </template>
                                    </v-list>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 sm7>
                        <v-layout>
                            <v-flex>
                                <h3 class="display-1"><b>Orden Activa:</b> {{ d.op.C2_NUM }}</h3>
                                <h3 class="display-1"><b>Cliente:</b> {{ d.op.A1_NOME }}</h3>
                                <h3 class="display-1"><b>Obs:</b> {{ d.op.C2_OBS }}</h3>
                                <h3 class="display-1"><b>Producto:</b> {{ d.producto_id }}</h3>
                            </v-flex>
                            <v-flex>
                                <v-card>
                                    <v-toolbar dense color="primary" class="white--text" dark>
                                        <v-btn @click="d.calidad = 'P'" icon flat small v-if="d.calidad !== 'P'">
                                            <v-icon>keyboard_arrow_left</v-icon>
                                        </v-btn>
                                        <v-toolbar-title>{{ titulo }}</v-toolbar-title>
                                    </v-toolbar>
                                    <v-slide-x-transition leave-absolute mode="out-in">
                                        <v-list key="p" dense v-if="d.calidad === 'P'">
                                            <template v-for="c in calidades">
                                                <v-list-tile @click="d.calidad = c.value">
                                                    <v-list-tile-action>
                                                        <v-icon v-if="d.calidad === c.value" color="green">check</v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        {{ c.text}}
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                            </template>
                                        </v-list>
                                        <v-list key="b" dense v-if="d.calidad === 'B'">
                                            <template v-for="f in fallas">
                                                <v-list-tile @click="d.reporte_falla_id = f.id">
                                                    <v-list-tile-action>
                                                        <v-icon v-if="d.reporte_falla_id === f.id" color="green">check</v-icon>
                                                    </v-list-tile-action>
                                                    <v-list-tile-content>
                                                        {{ f.desig}}
                                                    </v-list-tile-content>
                                                </v-list-tile>
                                            </template>
                                        </v-list>
                                    </v-slide-x-transition>
                                </v-card>
                            </v-flex>
                        </v-layout>
                        <v-layout>
                            <v-flex>
                                <table>
                                    <thead class="text-xs-center">
                                        <tr>
                                            <th>Prod</th>
                                            <th>Reportado</th>
                                            <th class="red--text">Reportar</th>
                                            <th>Pend</th>
                                            <th>UM</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td>{{ d.op.C2_QUANT | decimales }}</td>
                                            <td>{{ d.op.C2_REPWEB | decimales }}</td>
                                            <td class="red--text"> {{ d.cant | decimales }}</td>
                                            <td :class="{'red--text': pendienteM2 > 0}">{{ pendienteM2 | decimales }}</td>
                                            <td>M2</td>
                                        </tr>
                                        <tr>
                                            <td>{{ d.op.LARGO | decimales }}</td>
                                            <td>{{ repMts | decimales }}</td>
                                            <td class="red--text"> {{ d.MTS | decimales }}</td>
                                            <td :class="{'red--text': pendienteMts > 0}">{{ pendienteMts | decimales }}</td>
                                            <td>MTS</td>
                                        </tr>
                                        <tr>
                                            <td>{{ d.op.PIEZAS | decimales }}</td>
                                            <td>{{ repPzas | decimales }}</td>
                                            <td class="red--text">
                                                <input v-model="d.PIEZAS" @input="acualizaDatos('pza')">
                                            </td>
                                            <td :class="{'red--text': pendientePiezas > 0}">{{ pendientePiezas | decimales }}</td>
                                            <td>PIEZAS</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </v-flex>
                        </v-layout>
                        <v-layout align-center justify-center row>
                            <v-flex class="text-xs-center">
                                <v-btn large color="primary" @click="reportar()" :loading="loading">REPORTAR</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>
<script>
    import errores from '../../components/Errores';
    import empresaSelect from '../../components/EmpresaSelect.vue';
    import monedaSelect from '../../components/MonedaSelect.vue';
    import decimales from '../../filters/decimales';
    import userMixin from '../../mixins/auth/users';
    import pcpMixin from '../../mixins/pcp';
    import configMixin from '../../mixins/config';
    import itemMixin from '../../mixins/items';
    import {mapActions} from 'vuex';
    import numeral from 'numeral';

    function getInitialData() {
        return {
            producto_id: '',
            empresa_id: '',
            cant: 0,
            calidad: 'P',
            MTS: 0,
            PIEZAS: 0,
            op: {
                C2_LARGPZA: 0,
                B1_ANCHO: 0
            },
            recurso_id: '',
            reporte_falla_id: ''
        }
    }

    export default {
        components: {empresaSelect, monedaSelect, errores},
        mixins: [userMixin, configMixin, pcpMixin, itemMixin],
        filters: {
            estado: value => {
                if (value > 0) {
                    return 'yellow';
                } else {
                    return 'red';
                }
            },
            decimales
        },
        data() {
            return {
                selectProd: ['S', 'V', 'B'],
                menu: [],
                cantidad: '',
                dialog: false,
                opSel: false,
                errModal: false,
                resultado: '',
                loading: false,
                guardando: -1,
                ops: [],
                hora: '',
                diferencia: '',
                mostrarEmpresa: false,
                mostrarOper: false,
                emp: [],
                recursos: [],
                d: getInitialData(),
                calidades: [
                    {value: 'P', text: 'PRIMERA'},
                    {value: 'B', text: 'SEGUNDA'},
                    {value: 'S', text: 'SCRAP'},
                    {value: 'V', text: 'PRIMERA SIN PV'},
                ],
                fallas: [],
                productos: [],
                itemPage: 1,
            };
        },
        computed: {
            titulo() {
                if (this.d.calidad === 'P') {
                    return 'Calidad / Tipo';
                } else if (this.d.calidad === 'B') {
                    return 'Falla de 2º';
                } else if (this.d.calidad === 'S') {
                    return 'SCRAP';
                } else if (this.d.calidad === 'V') {
                    return 'PRIMERA SIN PV';
                }
            },
            pendienteM2() {
                let tot = 0;
                if (this.d.op.C2_QUANT) {
                    tot = this.d.op.C2_QUANT - this.d.op.C2_REPWEB - this.d.cant;
                }
                return tot;
            },
            pendienteMts() {
                let tot = 0;
                if (this.d.op.C2_QUANT) {
                    tot =
                        (this.d.op.C2_QUANT - this.d.op.C2_REPWEB - this.d.cant) /
                        this.d.op.B1_ANCHO;
                }
                return tot;
            },
            pendientePiezas() {
                let tot = 0;
                if (this.d.op.C2_QUANT) {
                    tot =
                        (this.d.op.C2_QUANT - this.d.op.C2_REPWEB - this.d.cant) /
                        this.d.op.B1_ANCHO /
                        this.d.op.C2_LARGPZA;
                }
                return tot;
            },
            repMts() {
                let tot = 0;
                if ((numeral(this.d.op.C2_QUANT).value() > 0) && (numeral(this.d.op.C2_REPWEB).value() > 0)) {
                    tot = (this.d.op.C2_QUANT - this.d.op.C2_REPWEB) / this.d.op.B1_ANCHO;
                }
                return numeral(tot).format('0.00');
            },
            repPzas() {
                let tot = 0;
                if ((numeral(this.d.op.C2_QUANT).value() > 0) && (numeral(this.d.op.C2_REPWEB).value() > 0)) {
                    tot = (this.d.op.C2_QUANT - this.d.op.C2_REPWEB) / this.d.op.B1_ANCHO / this.d.op.C2_LARGPZA;
                }
                return tot;
            }
        },
        mounted() {
            this.getUserEmpresas(r => {
                if (r.length > 1) {
                    this.mostrarEmpresa = true;
                    this.emp = r;
                } else {
                    this.d.empresa_id = r[0];
                    if (!this.d.empresa_id) {
                        this.msj = {mostrar: true, txt: 'Usuario sin empresa asignada', tipo: 'error'};
                        return false
                    }
                    this.getOp();
                    this.mostrarEmpresa = false;
                }
            });
            this.pcpFallas(r => {
                this.fallas = r;
            }, err => console.log(err))
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            acualizaDatos(tipo) {
                if (tipo === 'm2') {
                    this.d.MTS = numeral(this.d.cant / this.d.op.B1_ANCHO).format('0.00');
                    this.d.PIEZAS = numeral(
                        this.d.cant / this.d.op.B1_ANCHO / this.d.op.C2_LARGPZA
                    ).format('0.00');
                }
                if (tipo === 'pza') {
                    this.d.cant = numeral(
                        this.d.op.C2_LARGPZA * this.d.op.B1_ANCHO * this.d.PIEZAS
                    ).format('0.00');
                    this.d.MTS = numeral(this.d.cant / this.d.op.B1_ANCHO).format('0.00');
                }
                if (tipo === 'mt') {
                    this.d.cant = numeral(this.d.MTS * this.d.op.B1_ANCHO).format('0.00');
                    this.d.PIEZAS = numeral(
                        this.d.cant / this.d.op.B1_ANCHO / this.d.op.C2_LARGPZA
                    ).format('0.00');
                }
            },
            reportar() {
                if (!this.d.empresa_id || !this.d.recurso_id) {
                    this.msjShow({tipo: 2, txt: 'Debe seleccionar empresa y recurso'});
                    return false;
                }
                if (this.d.calidad === 'B' && !this.d.reporte_falla_id) {
                    this.msjShow({tipo: 2, txt: 'Debe seleccionar tipo de falla'});
                    return false;
                }
                this.loading = true;
                this.$http.post('pcp/ord-prod/reportar', {
                    empresa_id: this.d.empresa_id,
                    cant: this.d.cant,
                    op_id: this.d.op.op_id,
                    calidad: this.d.calidad,
                    recurso_id: this.d.recurso_id,
                    reporte_falla_id: this.d.reporte_falla_id,
                    producto_id: this.d.producto_id
                })
                    .then(r => {
                        this.msjShow(r.data);
                        this.loading = false;
                        this.getOp();
                    })
                    .catch(err => {
                        this.msjShow({tipo: 2, txt: 'Error al generar'});
                    });
            },
            prodSeleccion(p) {
                this.d.op = {
                    C2_REPWEB: 0,
                    C2_QUANT: 0,
                    B1_ANCHO: p.B1_ANCHO,
                    C2_LARGPZA: this.d.op.C2_LARGPZA
                };
                this.d.producto_id = p.B1_COD;
                this.d.cant = 0;
            },
            opSeleccion(op) {
                if (!op) {
                    this.loading = false;
                    return false;
                }
                this.loading = true;
                this.limpiar();
                this.$http
                    .post('recurso/desde-producto', {
                        empresa_id: this.d.empresa_id,
                        prod: op.C2_PRODUTO
                    })
                    .then(
                        r => {
                            let reportar = (op.C2_REPWEB > 0) ? op.C2_QUANT - op.C2_REPWEB : op.C2_QUANT;
                            this.mostrarOper = r.data.length > 1;
                            this.d.cant = numeral(reportar).format('0.00');
                            this.d.producto_id = op.C2_PRODUTO;
                            this.d.op = op;
                            this.acualizaDatos('m2');
                            this.loading = false;
                        },
                        r => {
                            this.loading = false;
                        }
                    );
            },
            limpiar() {
                this.d.cant = 0;
                this.d.MTS = 0;
                this.d.PIEZAS = 0;
                this.d.producto_id = '';
                this.d.calidad = 'P';
                this.d.reporte_falla_id = ''
            },
            getOp() {
                this.loading = true;
                this.configGet('opSel', r => { //obtengo configuracion sobre seleccion de op
                    this.opSel = r;
                    this.pcpLista(this.d, r => {
                        this.ops = r;
                        this.opSeleccion(this.ops[0]);
                        this.loading = false;
                    }, err => {
                        this.loading = false;
                        console.log(err)
                    });
                }, err => {
                    console.log(err)
                });
            },
            getRecursos() {
                this.pcpRecursos({emp: this.d.empresa_id}, r => {
                    this.recursos = r;
                }, err => console.log(err));
            },
            getProductos() {
                this.itemMicroSearchPag({
                    empresa_id: this.d.empresa_id,
                    page: this.itemPage,
                    q: this.d.producto_id
                }, r => {
                    r.data.forEach(p => {
                        this.productos.push(p)
                    });
                }, err => console.log(err))
            },
            handleItemScroll(e) {
                let el = e.srcElement;
                if (el.scrollTop >= (el.scrollHeight - el.offsetHeight)) {
                    this.itemPage++;
                    this.getProductos();
                }
            },
            prodSearch() {
                this.itemPage = 1;
                this.productos = [];
                this.getProductos();
            }
        }
    };
</script>
<style scoped lang="scss">
    .lista-cont {
        max-height: 400px;
        overflow-y: auto;
    }

    table {
        border-collapse: collapse;
        width: 100%;
        font-size: 34px;
        font-weight: 400;
        th {
            text-align: center;
            text-transform: uppercase;
        }
        td,
        td input {
            text-align: right;
        }
        td input {
            width: 100%;
        }
        td,
        th,
        tr {
            border: 1px solid rgba(0, 0, 0, 0.12);
            padding: 7px;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/pcp/reporte.vue